import { isEmptyObject } from "../utils/helper";
import {
    GET_EXPERTOPINION_BY_POST_ID,
} from "../utils/constants";

export const expertOpinionState = {
    listExpertOpinionByPostId: [],
};

export function expertOpinionReducer(state, action) {
    if (!action) {
        return state;
    }

    switch (action.type) {
        case GET_EXPERTOPINION_BY_POST_ID:
            return {
                ...state,
                listExpertOpinionByPostId:
                    action.payload && !isEmptyObject(action.payload)
                        ? action.payload.data
                        : [],
            };
        default:
            return state;
    }
}
